export default `
	guid
	updated_at
	name
	code
	active
`;
